/**
 * The different types of Notification entity the API knows about
 *
 * @example //getting the type of a notification
 * const status = metaNotificationType[notification.type]?.displayName;
 *
 * Matches definition in ResearcherPortal-Api:
 * https://msrceng.visualstudio.com/Workflows/_git/ResearcherPortal-Api?path=%2Fsrc%2FMicrosoft.Msrc.ResearcherPortal.Models%2FEnum%2FNotificationType.cs&_a=contents&version=GBmaster
 */
export const metaNotificationType = {
    ReportStatusChange: {
        displayName: 'Report status update',
        order: 0,
    },
    ReportStatusReasonChange: {
        displayName: 'Report status update',
        order: 10,
    },
    BountyStatusChange: {
        displayName: 'Bounty status update',
        order: 20,
    },
    NewMessageOnReport: {
        displayName: 'New message on report',
        order: 30,
    },
};
